import script from "./CollapsedExportItemRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollapsedExportItemRecord.vue?vue&type=script&lang=ts&setup=true"

import "./CollapsedExportItemRecord.vue?vue&type=style&index=0&id=6c2ea573&lang=scss"

const __exports__ = script;

export default __exports__